export default "__VITE_ASSET__CikKd55q__"